<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    @if (hasNotFullyCompleted()) {
      <info [option]="optionInfo1">
        La somme des pourcentages de répartition doit être égale à 100%.
      </info>
    }
    <info [option]="{ icon: 'info' }">
      {{ formattedInvestmentLabel }}
    </info>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let i = $index) {
        @if (i == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <ng-container formArrayName="corumProfiles">
                <div class="row">
                  <div class="col-md-12">
                    <pr-panel>
                      <div class="man pr-panel">
                        <pr-panel-body>
                          <div class="pr-panel-body">
                            <div
                              class="pr-card-swiper animated fadeIn relative overflow-hidden"
                            >
                              <table
                                class="pr-table-card-container"
                                style="width: 100%"
                              >
                                <tbody class="pr-table-card-statistics-body">
                                  <ng-container>
                                    <div
                                      class="pr-table-card-row ng-star-inserted"
                                    >
                                      @for (
                                        support of corumProfiles.controls;
                                        track support;
                                        let j = $index
                                      ) {
                                        <ng-container [formGroupName]="j">
                                          @if (j === 0) {
                                            <div
                                              class="pointer pr-table-card-row-container"
                                            >
                                              <div
                                                class="pr-table-card-cell grid-span-3 text-ellipsis"
                                              >
                                                <span
                                                  class="label-table bold text-ellipsis"
                                                >
                                                  Nom du profil
                                                </span>
                                              </div>
                                              <div
                                                class="pr-table-card-cell grid-span-1 text-ellipsis"
                                              >
                                                <span
                                                  class="label-table bold text-ellipsis"
                                                >
                                                  Investissement en %
                                                </span>
                                              </div>
                                            </div>
                                          }
                                          <div
                                            class="pointer pr-table-card-row-container"
                                          >
                                            <div
                                              class="pr-table-card-cell grid-span-3 text-ellipsis"
                                            >
                                              <span
                                                class="label-table text-ellipsis"
                                              >
                                                {{
                                                  support.get('label')?.value
                                                }}
                                              </span>
                                            </div>
                                            <div
                                              class="pr-table-card-cell grid-span-1 text-ellipsis"
                                            >
                                              <div
                                                class="d-flex"
                                                style="max-width: 300px"
                                              >
                                                <input
                                                  notdot
                                                  class="full-w percent"
                                                  formControlName="percentage"
                                                />
                                                <span style="margin-left: 3px"
                                                  >%</span
                                                >
                                              </div>
                                            </div>
                                          </div>
                                        </ng-container>
                                      }
                                    </div>
                                  </ng-container>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </pr-panel-body>
                      </div>
                    </pr-panel>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer
    (prev)="prev()"
    (next)="onSubmit()"
    [disabledSkip]="true"
    [disabledNext]="hasNotFullyCompleted()"
  ></form-footer>
</form>
